module.exports = __webpack_public_path__ + "img/alternate-link.2bf9dc4b.svg";